import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const PieChartOrderStage = ({ data, colors }) => {
  let mapData = [];
  let hasData = false;

  if (data && data.length > 0) {
    mapData = data.map(({ order_stage, Count_relocationId}) => ({
      name: order_stage,
      value: Count_relocationId,
      color: colors[order_stage],
    }));

    hasData = mapData.some(item => item.value > 0);
  }

  const defaultData = [{ name: "No Data", value: 1 }];
  const DEFAULT_COLOR = "#dddddd"; 

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0].payload;
      return (
        <div className="custom-tooltip">
          <p>{`${name}: ${value}`}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div>
      <PieChart width={345} height={345}>
        <Pie
          dataKey="value"
          data={hasData ? mapData : defaultData}
          cx={180}
          cy={150}
          outerRadius={140}
          innerRadius={90}
          fill="#8884d8"
        >
          {(hasData ? mapData : defaultData).map((entry, index) => (
           <Cell
           key={`cell-${index}`}
           fill={hasData && entry.color ? entry.color : DEFAULT_COLOR}
         />
         
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </div>
  );
};

export default PieChartOrderStage;
